import React from 'react';
import { Roadmap } from './Roadmap';

type Props = {};

const phases = [
  {
    title: 'Phase 1',
    completed: true,
    description: 
      "Sedition is launched with a mission to democratize access to fine art. Certificate of authenticity is introduced - Sedition's “internal” NFT.",
  },
  {
    title: 'Phase 2',
    completed: true,
    description: 
      'Public art displays around the world, including some of the largest screens across Asia, Europe and the United States. Partnerships with hotels, office buildings, airports etc to display the best art.',
  },
  {
    title: 'Phase 3',
    completed: true,
    description: "Art Stream, Sedition's subscription service, is introduced."
  },
  {
    title: 'Phase 4',
    completed: true,
    description: 
      'First artworks become NFTs, minting out of Vault mechanism implemented (selected artworks only, not implemented universally).',
  },
  {
    title: 'Phase 5',
    completed: false,
    description: 'Lazy minting implemented - buy NFTs with Ethereum and mint them directly.'},
  {
    title: 'Phase 6',
    completed: false,
    description: 
      'Utility attached to NFTs & Sedition Art Club NFTs - a unique collection drop that will unlock numerous benefits for Sedition NFT holders.',
  },
  {
    title: 'Phase 7',
    completed: false,
    description: 
      'It becomes possible to transfer ownership of every artwork on Sedition to the blockchain.',
  },
  {
    title: 'Phase 8',
    completed: false,
    description: 
      "Sedition's token launch & airdrop. Financial utility added to utility NFTs and Sedition Art Club NFTs.",
  },
];

export const RoadmapSection: React.FC<Props> = () => {
  return (
    <section>
      <Roadmap title='Roadmap' phases={phases} />
    </section>
  );
};
